import React from 'react';

const IconUser = () => (
  <svg id="user-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 512 512" space="preserve">
    <g>
      <g>
        <path d="M299.29,255.5h-86.58c-85.14,0-154.42,69.27-154.42,154.42V512h395.42V409.92C453.71,324.77,384.43,255.5,299.29,255.5z
			 M88.29,482v-72.08c0-68.61,55.82-124.42,124.42-124.42h86.58c68.6,0,124.42,55.81,124.42,124.42V482H88.29z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M256,0c-65.84,0-119.41,53.57-119.41,119.41S190.16,238.82,256,238.82s119.41-53.57,119.41-119.41S321.84,0,256,0z
			 M256,208.82c-49.3,0-89.41-40.11-89.41-89.41C166.59,70.11,206.7,30,256,30s89.41,40.11,89.41,89.41
			C345.41,168.71,305.3,208.82,256,208.82z"/>
      </g>
    </g>
  </svg>
);

export default IconUser;
